import { Partner } from '@geovelo-frontends/commons';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function useContactAdmin(): {
  contactAdmin: (partner: Partner) => void;
  adminToDisplay: Partner | null;
  closeAdminDialog: () => void;
} {
  const [adminToDisplay, setAdminToDisplay] = useState<Partner | null>(null);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  function contactAdmin(partner: Partner) {
    if (!partner.contactEmail) {
      enqueueSnackbar(t('companies.navigation.no_admin_contact'), { variant: 'error' });
      return;
    }

    setAdminToDisplay(partner);
  }

  return {
    contactAdmin,
    adminToDisplay,
    closeAdminDialog: () => setAdminToDisplay(null),
  };
}

export default useContactAdmin;
